import { CommunicationMethod, Position } from '@api'
import { z } from 'zod'

import HomeOutlineIcon from '@/assets/icons/icon-home-outline.svg'
import PersonOutlineIcon from '@/assets/icons/icon-person-outline.svg'

export const businessTypeOptions = [
  { label: 'Solo creator', value: Position.SOLO, icon: PersonOutlineIcon },
  { label: 'Agency', value: Position.AGENCY, icon: HomeOutlineIcon },
] as const

export const communicationOptions = [
  { label: 'Telegram', value: CommunicationMethod.TELEGRAM },
  { label: 'WhatsApp', value: CommunicationMethod.WHATS_APP },
] as const

export const referralOptions = [
  { label: 'Social Media', value: 'socialMedia' },
  { label: 'Online search', value: 'onlineSearch' },
  { label: 'Advertisement', value: 'advertisement' },
  { label: 'Influencer', value: 'influencer' },
  { label: 'Referral from a friend', value: 'friend' },
  { label: 'News blog or article', value: 'blog' },
  { label: 'Other', value: 'other' },
] as const

export const specifiableReferralOptions = [
  'socialMedia',
  'influencer',
  'blog',
  'other',
] as const

function getValues<T extends { label: string; value: string }>(
  options: Readonly<T[]>,
) {
  return options.map(({ value }) => value) as [T['value']]
}

const isEmpty = (value: string | undefined) =>
  value === undefined || value === ''

export const questionnaireFieldsSchema = z
  .object({
    businessType: z.enum(getValues(businessTypeOptions)),
    preferredCommunication: z.enum(getValues(communicationOptions)),
    referral: z.enum(getValues(referralOptions)),

    WhatsApp: z.string().optional(),
    Telegram: z.string().optional(),
    Email: z.string().optional(),

    socialMedia: z.string().optional(),
    influencer: z.string().optional(),
    blog: z.string().optional(),
    other: z.string().optional(),
  })
  .refine((data) => {
    for (const { value } of communicationOptions) {
      if (data.preferredCommunication === value && isEmpty(data[value])) {
        return false
      }
    }

    for (const option of specifiableReferralOptions) {
      if (data.referral === option && isEmpty(data[option])) {
        return false
      }
    }

    return true
  })

export const QUESTIONNAIRE_FORM_ID = 'questionnaireForm'
